module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_sapporo-e3cd5d4574224745f2c98b9067addf41.jpg";